import { render, staticRenderFns } from "./footprint.vue?vue&type=template&id=0d10b162&scoped=true&"
import script from "./footprint.vue?vue&type=script&lang=js&"
export * from "./footprint.vue?vue&type=script&lang=js&"
import style0 from "./footprint.vue?vue&type=style&index=0&id=0d10b162&prod&lang=scss&scoped=true&"
import style1 from "./footprint.vue?vue&type=style&index=1&id=0d10b162&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d10b162",
  null
  
)

export default component.exports